import { useGetDialogs } from '@yuno/dashboard-api-mfe'
import { DialogComponent } from '../dialog/dialog'
import { lazy, useContext, useEffect, useState } from 'react'
import { ContainerContext } from '../../context/container-context'
import { DialogTexts } from '../../utils/constants'
import { useBreadcrumb } from './hooks/breadcrumb'
import { useSnackbar } from './hooks/snackbar/snackbar.hook'
import { Alert, Button } from '@yuno/design-system-web'
import { storage } from '../../yuno-dashboard-container-mfe'
import { ButtonProps } from './layout-types'
import { useTranslation } from 'react-i18next'
const LayoutSnackBars = lazy(() => import('./layout-snackbars'))
import AppBarLayout from './appbar-layout'

function Layout() {
  const { t } = useTranslation()
  const [openDialog, setOpenDialog] = useState(false)
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [buttons, setButtons] = useState<ButtonProps[]>([])
  const [allowed, setAllowed] = useState(true)
  const { testingEnvironment, organizations, organizationCodeStaff } =
    useContext(ContainerContext)
  const handleOpenDialog = () => setOpenDialog((prev) => !prev)
  const response = useGetDialogs()

  const { section } = useBreadcrumb()
  const { snackOpen, onOpenSnackbar } = useSnackbar()
  const [infoHeader, setInfoHeader] = useState()
  useEffect(() => {
    storage.addListener('storage', (e) => {
      if (e.key === 'INFO_HEADER') {
        setInfoHeader(e.value)
      }
    })
  }, [])

  const handleClick = () => {
    setButtons([
      {
        variant: 'primary',
        label: t('dialogs.learn.done'),
        size: 'small',
        event: handleOpenDialog,
      },
    ])
    setTitle(t('dialogs.learn.title'))
    setContent(t('dialogs.learn.body'))
    handleOpenDialog()
  }

  useEffect(() => {
    localStorage.setItem('navigationList', location.pathname)
    localStorage.removeItem('navigationListError')
    const organizationSelected = organizations.data?.find(
      (item) => item.code === organizationCodeStaff,
    )
    if (organizationCodeStaff && organizationSelected.status !== 'ACTIVE') {
      setAllowed(false)
    }
    return () => {
      localStorage.removeItem('navigationList')
    }
  }, [])

  useEffect(() => {
    if (section !== '') {
      const state = history.state?.usr?.snackbar
      const navigationList = localStorage.getItem('navigationList')
        ? localStorage.getItem('navigationList')
        : ''
      const navigationArray = navigationList.split(',')
      navigationArray.push(location.pathname)
      navigationArray.length == 3 && navigationArray.shift()
      localStorage.setItem('navigationList', navigationArray.join(','))
      if (state) {
        onOpenSnackbar(DialogTexts.CONNECTION_FAILED, 'error', 'Info')
        history.replaceState({ snackbar: false }, '')
      }
    }
  }, [section])

  return (
    <>
      <div style={{ position: 'fixed', left: 0, right: 0, zIndex: 1000 }}>
        <DialogComponent
          allowed={!!organizationCodeStaff}
          openDialog={openDialog}
          title={title}
          buttons={buttons}
          handleOpenDialog={handleOpenDialog}
        >
          <>{<div dangerouslySetInnerHTML={{ __html: content }} />}</>
        </DialogComponent>
        {testingEnvironment && (
          <Alert severity="info">
            <>
              <span>{t('alert')}</span>
              <Button
                size="small"
                style={{
                  padding: 0,
                  fontSize: '14px',
                  minHeight: 0,
                  marginLeft: '20px',
                }}
                /* @ts-ignore */
                variant="link"
                onClick={handleClick}
                nonce={undefined}
              >
                {t('learn')}
              </Button>
            </>
          </Alert>
        )}
        <p style={{ position: 'absolute' }}>algo</p>
        <AppBarLayout
          infoHeader={infoHeader}
          allowed={allowed}
          setButtons={setButtons}
          setContent={setContent}
          setOpenDialog={setOpenDialog}
          setTitle={setTitle}
        />
      </div>
      {snackOpen && <LayoutSnackBars />}
    </>
  )
}
export default Layout
